export const compressObject = async (obj: object) => {
  const stream = new Blob([JSON.stringify(obj)], {
    type: "application/json",
  }).stream();

  const compressedReadableStream = stream.pipeThrough(
    // @ts-ignore
    new CompressionStream("gzip"),
  );

  const compressedResponse = await new Response(
    compressedReadableStream,
  ).blob();

  const buffer = await compressedResponse.arrayBuffer();

  return btoa(String.fromCharCode(...new Uint8Array(buffer)));
};

export function b64decode(str: string) {
  const binary_string = window.atob(str);
  const len = binary_string.length;
  const bytes = new Uint8Array(new ArrayBuffer(len));
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes;
}

export const uncompressObject = async (value: string) => {
  const stream = new Blob([b64decode(value)], {
    type: "application/json",
  }).stream();

  const compressedReadableStream = stream.pipeThrough(
    // @ts-ignore
    new DecompressionStream("gzip"),
  );

  const resp = await new Response(compressedReadableStream);
  const blob = await resp.blob();

  return JSON.parse(await blob.text());
};
